import { render, staticRenderFns } from "./encargos.vue?vue&type=template&id=100539f0&"
import script from "./encargos.vue?vue&type=script&lang=js&"
export * from "./encargos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports